import { render } from "./PhysicalTest.vue?vue&type=template&id=1b92b502&scoped=true"
import script from "./PhysicalTest.vue?vue&type=script&lang=js"
export * from "./PhysicalTest.vue?vue&type=script&lang=js"

import "./PhysicalTest.vue?vue&type=style&index=0&id=1b92b502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b92b502"]])

export default __exports__